import * as DataModel from "lib/data/model";

export class EntryService {

	public static getParentSections = (entry: DataModel.Entry): DataModel.Section[] => {

		// Initialize Section Array
		const sectionArray: DataModel.Section[] = [];

		// Loop Through Entry Parents
		for (const groupEntry of entry.parentGroupEntries) {

			// Check For Hierarchy
			if (groupEntry.parentGroup.sectionHierarchy.length > 0) {

				// Add Parent Section To List
				sectionArray.push(groupEntry.parentGroup.sectionHierarchy[groupEntry.parentGroup.sectionHierarchy.length - 1]);
			}
		}

		// Return Section Array
		return sectionArray;
	};
}
